export default "__VITE_ASSET__CVYqtipF__"